module.exports = __webpack_public_path__ + "fonts/WorkSans-Medium.e96e09f.woff2";